import { useState } from "react";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { useQueryClient } from "@tanstack/react-query";
import { useIsMobile } from "@/hooks/use-mobile";

export const ManualStockTriggerButton = () => {
  const [isTriggering, setIsTriggering] = useState(false);
  const { user } = useAuth();
  const queryClient = useQueryClient();
  const isMobile = useIsMobile();

  // Alleen tonen voor management/admin
  if (!user || user.role !== "management") {
    return null;
  }

  const handleTrigger = async () => {
    setIsTriggering(true);

    try {
      const { data, error } = await supabase.functions.invoke('monitor-stock-availability', {
        body: {
          source: 'manual_ui',
          skipBusinessHoursCheck: true,
          batchSize: 50,
          offset: 0
        }
      });

      if (error) throw error;

      toast.success("Voorraadcheck gestart!", {
        description: `${data?.scannedNotifications ?? 0} meldingen gescand • ${data?.inventoryChecksInserted ?? 0} checks opgeslagen.`
      });
      
      // Auto-refresh after 30 seconds with forced refetch
      setTimeout(() => {
        queryClient.invalidateQueries({ 
          queryKey: ['notifications'],
          refetchType: 'all'
        });
        queryClient.invalidateQueries({
          queryKey: ['stock-status']
        });
        toast.info("Meldingen ververst! Alle badges zijn bijgewerkt.");
      }, 30000);
      
    } catch (error: any) {
      console.error("Error triggering stock monitoring:", error);
      toast.error("Fout bij starten voorraadcheck", {
        description: error.message
      });
    } finally {
      setIsTriggering(false);
    }
  };

  return (
    <Button
      onClick={handleTrigger}
      disabled={isTriggering}
      variant="outline"
      size={isMobile ? "sm" : "default"}
      className="gap-2"
    >
      <RefreshCw className={`h-4 w-4 ${isTriggering ? 'animate-spin' : ''}`} />
      {isMobile ? "Check voorraad" : "Voorraad checken"}
    </Button>
  );
};
